import { css, styled, Theme } from "@mui/material";

import { getColor } from "@hooks";
import { cssForHeaderWithLinearGradient, cssPropertiesToString } from "utils";

interface HeaderContainerProps {
  withoutPadding: boolean;
}

export const HeaderContainer = styled("div", {
  shouldForwardProp: prop => prop !== "withoutPadding",
})<HeaderContainerProps>(
  ({ theme, withoutPadding }) => css`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;

    ${theme.breakpoints.up("mobile")} {
      padding: 8px 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      padding: 8px 38px;
    }

    ${theme.breakpoints.up("desktop")} {
      padding: 0 0;
    }

    ${theme.breakpoints.up("desktopXl")} {
      padding: 16px 0;
    }

    ${withoutPadding &&
    css`
      ${theme.breakpoints.up("mobile")} {
        padding: 0;
      }
    `}
  `,
);

const headerMaxWidth = "900px";

const headerStyles = (theme: Theme) => css`
  text-align: center;
  max-width: ${headerMaxWidth};

  ${cssForHeaderWithLinearGradient(theme)}

  ${theme.breakpoints.up("mobile")} {
    ${cssPropertiesToString(theme.typography.heading_h1_extrabold_mobile)}
  }

  ${theme.breakpoints.up("tablet")} {
    ${cssPropertiesToString(theme.typography.heading_h1_extrabold_tablet)}
  }

  ${theme.breakpoints.up("desktop")} {
    ${cssPropertiesToString(theme.typography.heading_h1_extrabold_desktop)}
  }
`;

export const MainHeader = styled("h1")(({ theme }) => headerStyles(theme));
export const SecondaryHeader = styled("span")(({ theme }) =>
  headerStyles(theme),
);

export const SubheaderContainer = styled("div")`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  max-width: ${headerMaxWidth};
`;

export const Subheader = styled("span")(
  ({ theme }) => css`
    ${cssPropertiesToString(theme.typography.paragraph_xxlarge_medium)}
  `,
);

export const SecondarySubheader = styled("span")(
  ({ theme }) => css`
    display: block;
    color: ${getColor(c => c.tokens.text["sub-600"], theme)};
    ${cssPropertiesToString(theme.typography.paragraph_xxlarge_medium)}
  `,
);

export const CaseStudyCaption = styled("span")(
  ({ theme }) => css`
    ${theme.breakpoints.up("mobile")} {
      ${cssPropertiesToString(theme.typography.paragraph_xsmall_medium)}
    }

    ${theme.breakpoints.up("tablet")} {
      ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
    }
  `,
);

export const BlogPostFooter = styled("div")(
  ({ theme }) => css`
    display: flex;

    ${theme.breakpoints.up("mobile")} {
      gap: 1rem;

      & span {
        ${cssPropertiesToString(theme.typography.paragraph_xsmall_medium)}
      }
    }

    ${theme.breakpoints.up("tablet")} {
      gap: 1.5rem;

      & span {
        ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
      }
    }
  `,
);
